<template>
  <div
    class="tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#FCFCFD]"
  >
    <div
      class="tw-w-[100%] tw-flex tw-flex-col tw-gap-[12px] !tw-break-inside-avoid"
    >
      <div
        id="chr-sheading-stats"
        class="tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-font-[Poppins] tw-w-fit"
      >
        {{ getComponentUiText("app-share-cyber-profile-stats-title-1") }}
      </div>
      <div
        class="tw-text-[#231F20] tw-text-[14px] tw-font-[Poppins] tw-font-normal tw-opacity-[0.7]"
      >
        {{
          getComponentUiText(
            "app-landing-share-assessments-status-description-1",
          )
        }}
      </div>
    </div>
    <div class="tw-flex tw-gap-[20px] tw-flex-col tw-w-full stats-container">
      <div
        class="tw-flex tw-w-full tw-gap-[20px] md:tw-flex-row tw-flex-col stats-row"
      >
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-carried-1',
            )
          "
          :value="
            checklistReportData?.checklistInfographics
              ?.checklistInfographicsHistoryCount
              ? checklistReportData?.checklistInfographics
                  ?.checklistInfographicsHistoryCount
              : 0
          "
        />
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-wep-app-1',
            )
          "
          :value="
            checklistReportData?.checklistInfographics
              ?.checklistInfographicsWebservicesCount
          "
        />
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-other-services-1',
            )
          "
          :value="valueOtherWebservicesCard"
        />
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-audit-assess-1',
            )
          "
          :value="
            checklistReportData?.checklistInfographics
              ?.checklistInfographicsItemCount
          "
        />
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
      </div>
      <div
        class="tw-flex tw-w-full tw-gap-[20px] lg:tw-flex-row tw-flex-col stats-row"
      >
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-audit-category-1',
            )
          "
        >
          <template #value>
            <div
              class="tw-max-w-[225px] tw-min-w-[225px] tw-flex tw-gap-[10px]"
            >
              <div
                class="tw-text-[#211F58] tw-font-[Poppins] tw-text-[35px] tw-font-semibold tw-leading-[100%]"
              >
                {{
                  checklistReportData?.checklistInfographics
                    ?.checklistInfographicsCatGt75
                }}/{{ checklistReportData?.checklistCategories?.length }}
              </div>
              <div
                class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[130%]"
              >
                {{
                  getComponentUiText(
                    "app-landing-share-assessments-status-card-audit-category-note-1",
                  )
                }}
              </div>
            </div>
          </template>
          <template #rightContent>
            <div class="vertical-rl tw-flex tw-items-center tw-h-full">
              <RadialProgressBar
                class="d-inline"
                :total-steps="100"
                :completed-steps="
                  (checklistReportData?.checklistInfographics
                    ?.checklistInfographicsCatGt75 /
                    checklistReportData?.checklistCategories?.length) *
                  100
                "
                :is-hide-progress="true"
                :diameter-default="80"
                :is-hide-responsive="false"
                inner-stroke-color="#F7553C"
              />
            </div>
          </template>
        </AssessmentValueCard>
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-low-cost-1',
            )
          "
        >
          <template #value>
            <div class="tw-max-w-[213px] tw-flex tw-gap-[15px]">
              <div
                class="tw-text-[#211F58] tw-font-[Poppins] tw-text-[35px] tw-font-semibold tw-leading-[100%]"
              >
                {{
                  checklistReportData?.checklistInfographics
                    ?.checklistInfographicsItemsLt90
                }}
              </div>
              <div
                class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[130%]"
              >
                {{
                  getComponentUiText(
                    "app-landing-share-assessments-status-card-low-cost-note-1",
                  )
                }}
              </div>
            </div>
          </template>
        </AssessmentValueCard>
        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
        <AssessmentValueCard
          v-if="!isLoading"
          :title="
            getComponentUiText(
              'app-landing-share-assessments-status-card-title-improvement-assessment-1',
            )
          "
          :custom-class="`${
            Number(scoreImprovementPersent.replace('%', '')) < 0
              ? 'tw-text-[#F7553C]'
              : ''
          }`"
          :value="scoreImprovementPersent"
        />

        <div
          v-else
          class="custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AssessmentValueCard from "@/components/share/assessmentValueCard.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed } from "vue";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import store from "@/store";

const props = defineProps({
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const checklistReportData = computed(
  () => store.getters["Sharing/getChecklistReportData"],
);

const servicesData = computed(() => store.state.Sharing.servicesData);

const currentOrg = computed(() => store.state.Org.currentOrg);

const checklistDate = computed(() => {
  return store.state.Sharing.checklistReportData?.checklistSummary
    ?.checklistDate;
});

const scoreImprovementPersent = computed(() => {
  const value =
    checklistReportData.value?.checklistInfographics
      ?.checklistInfographicsScoreImprovement * 100;
  return (
    (value ? (Number.isInteger(value) ? value : value.toFixed(1)) : 0) + "%"
  );
});

const valueOtherWebservicesCard = computed(() => {
  if (currentOrg.value.id === servicesData.value?.idOrg) {
    const valueServices =
      (servicesData.value?.sections &&
        servicesData.value?.sections[0]?.questions[0]?.values) ||
      [];
    const checklistDateToMs = new Date(checklistDate.value).getTime();

    const datafilter = valueServices.filter((item) => {
      const startDateToMs = item.startDate
        ? new Date(item.startDate).getTime()
        : new Date().getTime();
      const endDateToMs = item.endDate
        ? new Date(item.endDate).getTime()
        : new Date().getTime();

      return (
        startDateToMs <= checklistDateToMs && endDateToMs >= checklistDateToMs
      );
    });

    return datafilter.length;
  }

  return 0;
});
</script>

<style lang="scss" scoped>
@media print {
  .stats-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: hidden;
    margin: 0;
  }
}
</style>
